import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'

import NotFoundTemplate, { NotFoundTemplateProps } from '../templates/NotFound'
import { useDefaultLayoutProps } from '../layouts/DefaultLayout/useProps'
import { router, routesPath } from '../router'
import { useTracking } from '../tracking'

function Page404() {
  const { t } = useTranslation()
  const params = useParams<{ locale: string }>()
  const layoutProps = useDefaultLayoutProps()
  useTracking()

  const notFoundProps: NotFoundTemplateProps = useMemo(
    () => ({
      layout: layoutProps,
      title: t('notFound.title'),
      description: t('notFound.description'),
      cta: {
        text: t('notFound.cta'),
        link: {
          href: router(routesPath.home, { locale: params.locale ?? 'en' }),
        },
      },
    }),
    [layoutProps, t, params]
  )

  return <NotFoundTemplate {...notFoundProps} />
}

export default Page404
